import { AchRelationshipsPage } from './AchRelationshipsPage';

export default AchRelationshipsPage;
